import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import 'dayjs/locale/fr'

dayjs.extend(utc)

export const FORMAT_DDMMYYYY = 'DD/MM/YYYY'
export const FORMAT_MMDDYYYY = 'MM/DD/YYYY'
export const FORMAT_DDMMYYYY_VALIDATION_REGEXP = new RegExp(/^(31\/(0[13578]|10|12)|30\/(0[13-9]|1[0-2])|(0[1-9]|[12][0-9])\/(0[1-9]|1[0-2]))\/([0-9]{4})$/)

export function formatDate(date: string | Date): string {
  return dayjs(date).format('DD/MM/YYYY HH:mm')
}

export function formatDateDMY(date: string): string {
  return dayjs(date).format(FORMAT_DDMMYYYY)
}

export function formatDateUS(date: string): string {
  return dayjs(date).format(FORMAT_MMDDYYYY)
}

export function formatBirthday(birthday: string, isUS = false) {
  if (!birthday) return ''
  return dayjs.utc(birthday).format(isUS ? 'MM/DD/YYYY' : 'DD/MM/YYYY')
}
